module.exports = __webpack_public_path__ + "static/media/profilePicturePlaceholder.2df36190.svg";